<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper" v-if="showSaleFilters">
              <input-widget :placeholder="true" :label='false' :model="searchModel" attribute="auction_number"/>
            </div>
            <div class="input-wrapper" v-if="showSaleFilters">
              <b-form-group class="">
                <date-range-picker
                  class="d-flex w-100"
                  @update="onAuctionDateRangeApply"
                  showWeekNumbers
                  showDropdowns
                  ref="picker"
                  :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
                  v-model="auctionDateRange">
                  <template v-slot:input="picker" style="min-width: 350px;">
                    <span v-if="!picker.startDate" class="text-muted">
                      {{ $t('Sale Start - End Date') }}
                    </span>
                    <span style="font-size: 10px" v-else>
                      {{ picker.startDate | toDate }} - {{ picker.endDate | toDate }}
                    </span>
                  </template>
                </date-range-picker>
              </b-form-group>
            </div>
            <div class="input-wrapper">
              <input-widget :placeholder="true" :label='false' :model="searchModel" attribute="buyer_number"/>
            </div>
            <div class="input-wrapper">
              <input-widget :placeholder="true" :label='false' :model="searchModel" attribute="buyer_first_name"/>
            </div>
            <div class="input-wrapper">
              <input-widget :placeholder="true" :label='false' :model="searchModel" attribute="buyer_last_name"/>
            </div>
            <div class="input-wrapper">
              <input-widget :placeholder="true" :label='false' :model="searchModel" attribute="invoice_number"/>
            </div>
            <div class="input-wrapper">
              <input-widget :placeholder="true" :label='false' :model="searchModel" attribute="dpv_number"/>
            </div>
            <div class="input-wrapper">
              <b-form-group class="">
                <date-range-picker
                  class="d-flex w-100"
                  @update="onDateRangeApply"
                  showWeekNumbers
                  showDropdowns
                  ref="picker"
                  :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
                  v-model="dateRange">
                  <template v-slot:input="picker" style="min-width: 350px;">
                    <span v-if="!picker.startDate" class="text-muted">
                      {{ $t('Create At Date') }}
                    </span>
                    <span style="font-size: 10px" v-else>
                      {{ picker.startDate | toDate }} - {{ picker.endDate | toDate }}
                    </span>
                  </template>
                </date-range-picker>
              </b-form-group>
            </div>
          </div>
          <div class="search-btn-wrapper text-right">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import {SOURCE_DPV_HISTORY_TABLE} from "../constants";

  const {mapState, mapActions} = createNamespacedHelpers('dpv/dpv');

  export default {
    name: "SpvSearch",
    components: {InputWidget, DateRangePicker},
    data() {
      return {
        dateRange: {startDate: null, endDate: null},
        auctionDateRange: {startDate: null, endDate: null}
      }
    },
    computed: {
      ...mapState({
        tableSource: state => state.tableSource,
        searchModel: state => state.tableData[state.tableSource].searchModel,
      }),
      showSaleFilters() {
        return this.tableSource === SOURCE_DPV_HISTORY_TABLE;
      }
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage();
        this.getTableData();
      },
      onResetClick() {
        this.dateRange = {startDate: null, endDate: null};
        this.auctionDateRange = {startDate: null, endDate: null};
        this.resetTable();
      },
      onDateRangeApply() {
        this.searchModel.dateRange = this.dateRange;
      },
      onAuctionDateRangeApply() {
        this.searchModel.auctionDateRange = this.auctionDateRange;
      }
    },
    mounted() {
      if (this.searchModel) {
        if (this.searchModel.auctionDateRange) {
          this.auctionDateRange = this.searchModel.auctionDateRange;
        }
        if (this.searchModel.dateRange) {
          this.dateRange = this.searchModel.dateRange;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
